import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';

import { mapState, mapActions } from 'vuex';
import { moveNodeByWorldPosition, resetAndStopAnimation } from '@ps/bridge/qc/node';
import { setAdpaterData } from '@ps/bridge/qc/scripts/vertical-horizontal';
import { convertCoordinateByWorldScale, getNodeWorldPosition, isFirstLevelNodeInScene, isIvGroup } from '@ps/bridge/qc/base';
import * as layoutScript from '@ps/bridge/qc/scripts/layout';
import _ from 'lodash';
import { EventBus, Event } from '@ps/utils/event-bus';
import ScreenSplitProp from '@ps/views/workbench/right-pane/screen-split-prop.vue';
import { getUnSplitPropValue, setUnSplitPropValue } from '@ps/bridge/qc/scripts/editor';
import { updateScaleTween } from '@ps/workbench/animation';
import { checkIsSupportTweenScaleSplit } from '@ps/store/workbench/visual-program/utils';

export default {
  props: {
    config: {
      type: Object
    },
    formValue: {
      type: Object
    }
  },
  components: {
    ScreenSplitProp: ScreenSplitProp
  },
  data: function data() {
    return {
      x: this.formValue.psScript[this.config.prop].x.toFixed(2),
      y: this.formValue.psScript[this.config.prop].y.toFixed(2),
      positionMap: {
        from: this.$t('workbench.animation.qcPoint.positionMap.from'),
        to: this.$t('workbench.animation.qcPoint.positionMap.to')
      },
      scaleMap: {
        from: this.$t('workbench.animation.qcPoint.scaleMap.from'),
        to: this.$t('workbench.animation.qcPoint.scaleMap.to')
      },
      tweenScaleSplitProp: false,
      tweenScaleSplit: false
    };
  },

  computed: _extends({}, mapState({
    activeNode: function activeNode(state) {
      return state.workspace.game.activeNode;
    },
    adapterResolution: function adapterResolution(state) {
      return state.workspace.game.device.adapterResolution;
    }
  }), {
    isScaleType: function isScaleType() {
      return this.config.class === 'qc.TweenScale';
    },
    isTweenPosition: function isTweenPosition() {
      return this.config.class === 'qc.TweenPosition';
    },
    pointLabel: function pointLabel() {
      var map = this.positionMap;
      if (this.isScaleType) {
        map = this.scaleMap;
      }
      return map[this.config.prop];
    },
    spliptName: function spliptName() {
      return 'tweenScale-' + this.formValue.uuid;
    }
  }),
  watch: {
    adapterResolution: function adapterResolution(v) {
      var _this = this;

      setTimeout(function () {
        _this.initData();
      }, 200);
    },
    formValue: function formValue(v) {
      this.getTweenScaleSplitProp();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.tweenScaleSplit = checkIsSupportTweenScaleSplit();
    this.initData();
    EventBus.$on(Event.ANIMATION_UPDATE, function () {
      _this2.initData();
    });
    this.getTweenScaleSplitProp();
  },

  methods: _extends({}, mapActions({
    setStyle: 'workspace/game/setStyle',
    destroyVirtualNodeGhost: 'workspace/stage/destroyVirtualNodeGhost',
    addGhost: 'workspace/animation/addGhost',
    setAnimation: 'workspace/game/setAnimation'
  }), {
    // 读取横竖屏位移数据
    initData: function initData() {
      if (this.isScaleType) {
        this.x = this.formValue.psScript[this.config.prop].x;
        this.y = this.formValue.psScript[this.config.prop].y;
      } else {
        this.activeNode.x = this.formValue.psScript[this.config.prop].x;
        this.activeNode.y = this.formValue.psScript[this.config.prop].y;
        var worldPosition = getNodeWorldPosition(this.activeNode);
        this.x = worldPosition.x.toFixed(2);
        this.y = worldPosition.y.toFixed(2);
      }
    },
    setPointValue: function setPointValue() {
      // 没办法，这里只能这么写，青瓷是的属性编辑界面时分开写的，我们是公用组件，没法区分，只能通过动画的名字区分设置那个属性
      if (this.isTweenPosition) {
        var worldPosition = getNodeWorldPosition(this.activeNode);
        this.x = worldPosition.x.toFixed(2);
        this.y = worldPosition.y.toFixed(2);
      } else if (this.isScaleType) {
        this.x = Number(this.activeNode.scaleX.toFixed(2));
        this.y = Number(this.activeNode.scaleY.toFixed(2));
      }
      var logicX = this.x;
      var logicY = this.y;
      if (!this.isScaleType) {
        logicX = this.activeNode.x;
        logicY = this.activeNode.y;
      }
      var point = _.cloneDeep(this.config.script[this.config.prop]);
      point.x = logicX;
      point.y = logicY;
      this.setAnimation({
        animations: _defineProperty({
          uuid: this.formValue.uuid
        }, this.config.prop, point),
        node: this.activeNode
      });
      resetAndStopAnimation(this.activeNode);
      this.updateGhostNode();
      if (this.isTweenPosition) {
        this.updateAdapterData(logicX, logicY);
      } else if (this.isScaleType && this.tweenScaleSplit) {
        this.updateAdapterDataScale(logicX, logicY);
      }
    },
    changeX: function changeX(v) {
      var preNodes = [{
        x: this.activeNode.x,
        y: this.activeNode.y,
        uuid: this.activeNode.uuid
      }];
      var logicX = v;
      var logicY = this.formValue.psScript[this.config.prop].y;
      if (!this.isScaleType) {
        var worldPosition = getNodeWorldPosition(this.activeNode);
        var factPosition = convertCoordinateByWorldScale({
          x: v,
          y: worldPosition.y
        });
        moveNodeByWorldPosition({
          node: this.activeNode,
          x: factPosition.x,
          y: factPosition.y
        });
        logicX = this.activeNode.x;
        logicY = this.activeNode.y;
        this.setStyle({
          nodes: [{
            x: this.activeNode.x,
            y: this.activeNode.y,
            uuid: this.activeNode.uuid
          }],
          preNodes: preNodes
        });
      }
      var point = _.cloneDeep(this.config.script[this.config.prop]);
      point.x = logicX;
      point.y = logicY;
      this.setAnimation({
        animations: _defineProperty({
          uuid: this.formValue.uuid
        }, this.config.prop, point),
        node: this.activeNode
      });
      resetAndStopAnimation(this.activeNode);
      this.updateGhostNode();
      if (this.isTweenPosition) {
        this.updateAdapterData(this.activeNode.x, this.activeNode.y);
      } else if (this.isScaleType && this.tweenScaleSplit) {
        this.updateAdapterDataScale(logicX, logicY);
      }
    },
    changeY: function changeY(v) {
      var preNodes = [{
        x: this.activeNode.x,
        y: this.activeNode.y,
        uuid: this.activeNode.uuid
      }];
      var logicX = this.formValue.psScript[this.config.prop].x;
      var logicY = v;
      if (!this.isScaleType) {
        var worldPosition = getNodeWorldPosition(this.activeNode);
        var factPosition = convertCoordinateByWorldScale({
          x: worldPosition.x,
          y: v
        });
        moveNodeByWorldPosition({
          node: this.activeNode,
          x: factPosition.x,
          y: factPosition.y
        });
        logicX = this.activeNode.x;
        logicY = this.activeNode.y;
        this.setStyle({
          nodes: [{
            x: this.activeNode.x,
            y: this.activeNode.y,
            uuid: this.activeNode.uuid
          }],
          preNodes: preNodes
        });
      }
      var point = _.cloneDeep(this.config.script[this.config.prop]);
      point.x = logicX;
      point.y = logicY;
      this.setAnimation({
        animations: _defineProperty({
          uuid: this.formValue.uuid
        }, this.config.prop, point),
        node: this.activeNode
      });
      resetAndStopAnimation(this.activeNode);
      this.updateGhostNode();
      if (this.isTweenPosition) {
        this.updateAdapterData(this.activeNode.x, this.activeNode.y);
      } else if (this.isScaleType && this.tweenScaleSplit) {
        this.updateAdapterDataScale(logicX, logicY);
      }
    },

    // 同步更新虚拟节点样式
    updateGhostNode: function updateGhostNode() {
      var _this3 = this;

      this.destroyVirtualNodeGhost();
      setTimeout(function () {
        // 延迟创建，保证节点外观设置完成
        _this3.addGhost({
          node: _this3.activeNode,
          animation: _this3.activeNode.scripts.find(function (item) {
            return item.uuid === _this3.formValue.uuid;
          })
        });
      }, 50);
    },

    // 记录横竖屏位移数据
    updateAdapterData: function updateAdapterData(logicX, logicY) {
      var posData = {};
      if (isFirstLevelNodeInScene(this.activeNode) || isIvGroup(this.activeNode.parent)) {
        var layout = layoutScript.getScript(this.activeNode, false);
        if (layout) {
          posData.left = _.get(layout.layoutData, this.adapterResolution + '.left');
          posData.right = _.get(layout.layoutData, this.adapterResolution + '.right');
          posData.top = _.get(layout.layoutData, this.adapterResolution + '.top');
          posData.bottom = _.get(layout.layoutData, this.adapterResolution + '.bottom');
          posData.centerX = _.get(layout.layoutData, this.adapterResolution + '.centerX');
          posData.centerY = _.get(layout.layoutData, this.adapterResolution + '.centerY');
        } else {
          posData = { x: logicX, y: logicY };
        }
      } else {
        posData = { x: logicX, y: logicY };
      }
      setAdpaterData(this.activeNode, 'tweenPosition.' + this.formValue.psScript.uuid + '.' + this.config.prop, posData, this.adapterResolution);
    },

    // 记录横竖屏缩放数据
    updateAdapterDataScale: function updateAdapterDataScale(logicX, logicY) {
      var posData = { x: logicX, y: logicY };
      setAdpaterData(this.activeNode, 'tweenScale.' + this.formValue.psScript.uuid + '.' + this.config.prop, posData, this.adapterResolution);
    },
    getTweenScaleSplitProp: function getTweenScaleSplitProp() {
      this.tweenScaleSplitProp = getUnSplitPropValue(this.activeNode, this.spliptName);
    },
    changeTweenScaleSplitProp: function changeTweenScaleSplitProp(value) {
      this.tweenScaleSplitProp = value;
      setUnSplitPropValue(this.activeNode, this.spliptName, value);
      if (value) {
        updateScaleTween(this.activeNode, true);
      }
    }
  })
};